<h3 class="text-center">Invoice List</h3>
<div class="table-responsive" *ngIf="invoices.length>0">
<table datatable [dtOptions]="dtOptions" class="table table-striped display compact" >
    <thead>
    <tr>
        <th>Date Created</th>
        <th>Order Id</th>
        <th>Collector</th>
        <th>Guardian</th>
        <th>Student</th>
        <th>Total Amount</th>
        <th>Amount Paid</th>
        <th>Payment Status</th>
        <th>Payment Date</th>
        <th>Order Items</th>
        <th>Status</th>
        <th>Is Paid</th>
        <th>Is FullFilled</th>
        <th>Is Completed</th>
        <th>Verify</th>
    </tr>
    </thead>
    
    <tbody>
    
        <tr *ngFor="let invoice of invoices;">
        <td>{{invoice.datecreated}} </td>
        <td>{{invoice.paymentOrderId}}</td>
        <td>{{invoice.collectionServiceProvider}}</td>
        <td>{{invoice.guardianNames}}</td>
        <td>{{invoice.studentNames}}</td>
        <td>{{invoice.totalAmount}}</td>
        <td>{{invoice.amountPaid}}</td>
        <td>{{invoice.paymentStatus}}</td>
        <td>{{invoice.paymentDate}}</td>
        <td>{{invoice.status}}</td>
        <td>{{invoice.isPaid}}</td>
        <td>
            <a [routerLink]="['/admin/invoice/show']" [queryParams]="{invoiceId:invoice.id}">
                {{invoice.orderItemCount}}
            </a> 
        </td>
        <td>{{invoice.isFullFilled}}</td>
        <td>{{invoice.isCompleted}}</td>
        <td><button  (click)="verifyInvoice(invoice.id)">Verify</button></td>
    </tr>
    
    </tbody>
     
</table>

</div>